import { render, staticRenderFns } from "./distribute-case-info-export.vue?vue&type=template&id=86dabd6c&scoped=true"
import script from "./distribute-case-info-export.vue?vue&type=script&lang=ts"
export * from "./distribute-case-info-export.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86dabd6c",
  null
  
)

export default component.exports